import { useQuery } from "@tanstack/react-query";
import { CalculatorKeys } from "web_myplann/Api/Calculators/CalculatorKeys";
import { getCalculatorConsumerLoanSettingsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useConsumerLoanSettingsQuery = () =>
	useQuery({
		queryKey: CalculatorKeys.consumerLoanSettings(),
		queryFn: processResponse(() => getCalculatorConsumerLoanSettingsV2(), {
			skipToastFor: true,
		}),
	});
